import { render, staticRenderFns } from "./home-status-page.vue?vue&type=template&id=2fd15bdd&scoped=true"
import script from "./home-status-page.vue?vue&type=script&lang=js"
export * from "./home-status-page.vue?vue&type=script&lang=js"
import style0 from "./home-status-page.vue?vue&type=style&index=0&id=2fd15bdd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd15bdd",
  null
  
)

export default component.exports